import React, { memo, useCallback, useEffect, useState } from "react";
import { Card, Input, Controller, Button, SelectBox, AddRole, EditRole } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch, message } from "antd";
import {
  useGetAdminGetAllChannelsList,
  useGetAdminUsersList,
  useGetAuthorityFindCategory,
  useGetAuthorityFindRoles,
  usePutAdminUpdateChannelAndGroup,
} from "core";
import { useParams } from "react-router-dom";
import LoadingView from "../../atoms/loadingView";

const CONVERSATIONTITLE = "conversationTitle";
const ADDS = "adds";
const REMOVES = "removes";
const ADD_ADMINS = "addAdmins";
const REMOVE_ADMINS = "removeAdmins";
const ADD_ROLES="addRoles";
const REMOVE_ROLES="removeRoles";
const ADD_CATEGORY="addCategories";
const REMOVE_CATEGORY="removeCategories";
const ISMANDATORY="isMandatory";
const ADMINISTRATOR="administrator";
const SUPERVISOR="supervisor"

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditChannel = memo(() => {
  const { i18n } = useTranslation();
  const { id } = useParams();
  const [messageApi, contextHolder] = message.useMessage();

  const { data: { data: dataChannel} = {} ,refetch,isFetching:channelListFetch} =
    useGetAdminGetAllChannelsList({
      pageNumber: "1",
      pageSize: "1",
      channelId: id,
    });

 

  const { data: { data: allUserData } = {} ,refetch:refetchUser} = useGetAdminUsersList({
    pageNumber: "1",
    pageSize: "3000",
  });


  const[mandatory,setMandatory]=useState(false)

  useEffect(() => {
    setMandatory(dataChannel?.conversations?.[0]?.mandatory)
    if (dataChannel && !isPending) {
      reset({
        conversationTitle: dataChannel?.conversations?.[0]?.title,
        administrator:dataChannel?.conversations?.[0]?.administrator?.user_name,
        supervisor:dataChannel?.conversations?.[0]?.supervisor?.user_name,
      });
    }
  }, [dataChannel]);


  
  const options=allUserData?.users?.map(
    (item: any) => {
      return{
       value:item.userName,
       label:item.nameAndFamily
      } 
       ;
    }
  );

  const{data:allRoleData}=useGetAuthorityFindRoles({
    pageNumber:"1",
    pageSize:"3000"
  })

  const {data:categoriesData,refetch:categoriesRefetch}=useGetAuthorityFindCategory(
    {
      pageNumber:"1",
      pageSize:"1000"
    }
  )

 
  

  const methods = useForm({
    defaultValues: {
      conversationTitle: "",
      adds: [],
      removes: [],
      addAdmins: [],
      removeAdmins: [],
      addRoles:[],
      removeRoles:[],
      addCategories:[],
      removeCategories:[],
      administrator:"",
      supervisor:"",
      isMandatory:mandatory
    },
  });
  

  const { handleSubmit, reset } = methods;

  const onSubmit = useCallback(
    ({
      conversationTitle,
      adds,
      removes,
      addAdmins,
      removeAdmins,
      addRoles,
      removeRoles,
      addCategories,
      removeCategories,
      administrator,
      supervisor
    }: {
      conversationTitle: string;
      adds: any[];
      removes: any[];
      addAdmins: any[];
      removeAdmins: any[];
      addRoles:any[];
      removeRoles:any[];
      addCategories:any[];
      removeCategories:any[];
      administrator:string;
      supervisor:string;
      isMandatory:boolean
    }) => {
      mutate({
        requestBody: {
          conversationId: id || "",
          conversationTitle,
          ...(adds?.length && { adds: adds }),
          ...(removes?.length && { removes: removes }),
          ...(addAdmins?.length && { addAdmins: addAdmins }),
          ...(removeAdmins?.length && { removeAdmins: removeAdmins }),
          ...(addRoles?.length && {addRoles:addRoles}),
          ...(removeRoles?.length && {removeRoles:removeRoles}),
          ...(addCategories?.length && {addCategories:addCategories}),
          ...(removeCategories?.length && {removeCategories:removeCategories}),
          administrator:administrator||"",
          supervisor:supervisor||"",
          isMandatory:mandatory,
        },
      });
    },
    []
  );

  

  const { mutate, isPending } = usePutAdminUpdateChannelAndGroup({
    onSuccess: () => {
      reset();
      messageApi.open({
        type: "success",
        content: i18n.t("done"),
      });
      refetch()
      refetchUser()
      categoriesRefetch()
    },
  });

  
  //Role////////////////////////////////////////
  const deleteRoles=dataChannel?.conversations?.[0]?.roles?.map((item:any)=>{
    return item.name
  })

  const deleteRolesItems=deleteRoles?.map((item:any)=>{
    return {
      value: item,
      label: item,
    };
  })

  const addRole=allRoleData?.data?.roles?.filter((item:any)=>{return !deleteRoles?.includes(item.name)})

  const addRolesItems=addRole?.map((item:any)=>{
    return {
      value: item.name,
      label: item.name,
    };
  })
  ///////////////////////////////////////////////
  const chanelParticipants=dataChannel?.conversations?.[0]?.participants?.map((item:any)=>{return item})
  const channelAdmins=dataChannel?.conversations?.[0]?.admins?.map((item:any)=>{return item})

  let userNamesToRemoveFromAllUserData = new Set(chanelParticipants?.map((user:any) =>{return user.user.user_name}));
  let userNamesToRemoveFromAllGroupParticipants=new Set(channelAdmins?.map((user:any) =>{return user.user_name}))
  
  let filteredAllUserData = allUserData?.users.filter((user:any) => {return !userNamesToRemoveFromAllUserData.has(user?.userName)});
  let filteredAllAdmins=chanelParticipants?.filter((user:any)=>{return !userNamesToRemoveFromAllGroupParticipants.has(user?.user?.user_name)})


  const addItems=filteredAllUserData?.map((item:any)=>{
    return {
     value:item.userName,
     label:item.nameAndFamily
    }
 })
 const removeItems=chanelParticipants?.map((item:any)=>{
   return{
     value:item.user.user_name,
     label:item.user.name_and_family
   } })


 const addAdminsItem=filteredAllAdmins?.map((item:any)=>{
    return {
     value:item.user.user_name,
     label:item.user.name_and_family
    }
 })

 const removeAdminsItem=channelAdmins?.map((item:any)=>{
   return {
    value:item.user_name,
    label:item.name_and_family
   }
})
//////////////////////////////////////////////////////////////////////////

const deleteCategories=dataChannel?.conversations?.[0]?.categories?.map((item:any)=>{
  return item
})
const _deleteCategories=dataChannel?.conversations?.[0]?.categories?.map((item:any)=>{
  return item.id
})


const deleteCategoriesItems=deleteCategories?.map((item:any)=>{
  return {
    value: item.id,
    label: item.name,
  };
})

const addCategories=categoriesData?.data?.categories?.filter((item:any)=>{return !_deleteCategories?.includes(item.id)})

const addCategoriesItems=addCategories?.map((item:any)=>{
  return {
    value: item.id,
    label: item.name,
  };
})

  return (
    <>
      {contextHolder}
      <LoadingView isLoading={channelListFetch}>
      <Card title={i18n.t("EditChannel")}>
        <FormProvider {...methods}>
          <Form
            {...layout}
            name="nest-messages"
            onFinish={handleSubmit(onSubmit)}
          >
            <Form.Item>
              <Controller name={CONVERSATIONTITLE}>
                <Input placeholder={i18n.t("name")} />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={ADDS}>
                <SelectBox
                  mode="tags"
                  aria-multiselectable
                  label={i18n.t("addItems")}
                  options={addItems}
                  placeholder={i18n.t("choose")}
                />
              </Controller>
            </Form.Item>

            <Form.Item>
              <Controller name={REMOVES}>
                <SelectBox
                  mode="tags"
                  aria-multiselectable
                  label={i18n.t("removeItems")}
                  options={removeItems}
                  placeholder={i18n.t("choose")}
                />
              </Controller>
            </Form.Item>

             <Form.Item>
        <Controller name={ADD_ADMINS}>
          <SelectBox
            mode="tags"
            aria-multiselectable
            label={i18n.t("addAdminsItem")}
            options={addAdminsItem}
            placeholder={i18n.t("choose")}
          />
        </Controller>
      </Form.Item>

      <Form.Item>
        <Controller name={REMOVE_ADMINS}>
          <SelectBox
            mode="tags"
            aria-multiselectable
            label={i18n.t("removeAdminsItem")}
            options={removeAdminsItem}
            placeholder={i18n.t("choose")}
          />
        </Controller>
      </Form.Item> 

      <Form.Item>
        <Controller name={ADD_ROLES}>
          <SelectBox
            mode="tags"
            aria-multiselectable
            label={i18n.t("addRole")}
            options={addRolesItems}
            placeholder={i18n.t("choose")}
          />
        </Controller>
      </Form.Item> 

      <Form.Item>
        <Controller name={REMOVE_ROLES}>
          <SelectBox
            mode="tags"
            aria-multiselectable
            label={i18n.t("removeRole")}
            options={deleteRolesItems}
            placeholder={i18n.t("choose")}
          />
        </Controller>
      </Form.Item> 


      <Form.Item>
        <Controller name={ADD_CATEGORY}>
          <SelectBox
            mode="tags"
            aria-multiselectable
            label={i18n.t("addCategory")}
            options={addCategoriesItems}
            placeholder={i18n.t("choose")}
          />
        </Controller>
      </Form.Item> 

      <Form.Item>
        <Controller name={REMOVE_CATEGORY}>
          <SelectBox
            mode="tags"
            aria-multiselectable
            label={i18n.t("removeCategory")}
            options={deleteCategoriesItems}
            placeholder={i18n.t("choose")}
          />
        </Controller>
      </Form.Item> 

      <Form.Item>
              <Controller
             name={ADMINISTRATOR}
                disabled
              >
                <SelectBox
                allowClear
                  label={i18n.t("administrator")}
                  placeholder={i18n.t("administrator")}
                  options={options}
                />
              </Controller>
            </Form.Item>


            <Form.Item>
              <Controller
             name={SUPERVISOR}
                disabled
              >
                <SelectBox
                allowClear
                  label={i18n.t("supervisor")}
                  placeholder={i18n.t("supervisor")}
                  options={options}
                />
              </Controller>
            </Form.Item>

      
      <Form.Item label={i18n.t("mandatory")}>
              <Controller name={ISMANDATORY}>
                <Switch onClick={()=>{setMandatory(!mandatory)}} checked={mandatory}/>
              </Controller>
            </Form.Item>

      

            <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
              <Button
                style={{ width: "100px" }}
                type="primary"
                isLoading={isPending}
                htmlType="submit"
              >
                {i18n.t("update")}
              </Button>
            </Form.Item>
          </Form>
        </FormProvider>
      </Card>
      </LoadingView>
    </>
  );
});
export { EditChannel };
